import React from "react";
import ShareButton from "../components/ShareButton";
import { useTranslation } from "react-i18next";
import "../i18n";

export default function MenuButtons({
  setAluminumColor,
  setGlassColor,
  setGlassColor2,
  isOpen,
  handleToggle,
  controlsRef,
  rendererRef,
  sceneRef,
  cameraRef,
  isMobile,
  isEditMode,
  params,
  config }) {

  const buttonStyle = {
    padding: isMobile ? "6px 8px" : "6px 14px",
    fontSize: isMobile ? "11px" : "14px",
    fontWeight: "500",
    borderRadius: "8px",
    border: "none",
    color: "white",
    backgroundColor: "#81153F",
    cursor: "pointer",
    touchAction: "manipulation",
    boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
    minWidth: 60,
  };

  const { t } = useTranslation();

  if (isMobile) {
    return (<div
      style={{
        marginTop: 10,
        display: "flex",
        justifyContent: "space-around",
        padding: "4px 0",
        gap: 6,
      }}
    >
      <button onClick={handleToggle} style={buttonStyle}>
        {!isOpen ? t("openGlass") : t("closeGlass")}
      </button>

      {!isEditMode && (
        <>
          <button
            onClick={() => {
              controlsRef.current?.reset();
              controlsRef.current?.object.position.set(5, 3, 5);
              controlsRef.current?.target.set(0, 0, 0);
              controlsRef.current?.update();
              setAluminumColor(config.almColor);
              setGlassColor(config.glassColor);
              setGlassColor2(config.glassColor2);
            }}
            style={buttonStyle}
          >
            {t("reset")}
          </button>

          <button
            onClick={() => {
              const gl = rendererRef.current;
              const scene = sceneRef.current;
              const camera = cameraRef.current;
              if (!gl || !scene || !camera) return;
              gl.render(scene, camera);
              const dataURL = gl.domElement.toDataURL("image/png");
              const link = document.createElement("a");
              link.download = "cam-balkon.png";
              link.href = dataURL;
              link.click();
            }}
            style={buttonStyle}
          >
            {t("download")}
          </button>

          <ShareButton style={buttonStyle} isMobile={isMobile} params={params} />
        </>
      )}
    </div>);
  } else {
    return (
      <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 12 }}>
        <button style={buttonStyle} onClick={handleToggle}>
          {!isOpen ? t("openGlass") : t("closeGlass")}
        </button>

        {!isEditMode && (
          <>
            <button
              style={buttonStyle}
              onClick={() => {
                if (!controlsRef.current) return;
                controlsRef.current.reset();
                controlsRef.current.object.position.set(5, 3, 5);
                controlsRef.current.target.set(0, 0, 0);
                controlsRef.current.update();
                setAluminumColor(config.almColor);
                setGlassColor(config.glassColor);
                setGlassColor2(config.glassColor2);
              }}
            >
              {t("reset")}
            </button>

            <button
              style={buttonStyle}
              onClick={() => {
                const gl = rendererRef.current;
                const scene = sceneRef.current;
                const camera = cameraRef.current;
                if (!gl || !scene || !camera) return;
                gl.render(scene, camera);
                const dataURL = gl.domElement.toDataURL("image/png");
                const link = document.createElement("a");
                link.download = "cam-balkon.png";
                link.href = dataURL;
                link.click();
              }}
            >
              {t("download")}
            </button>

            <ShareButton style={buttonStyle} isMobile={isMobile} params={params} />
          </>
        )}
      </div>
    );
  }

}
